// import mapboxgl, {
//   AnySourceData,
//   EventData,
//   MapboxGeoJSONFeature,
//   MapboxOptions,
//   MapLayerEventType,
// } from "mapbox-gl"; // Should be fine
// import mapboxgl, { AnySourceData, SymbolLayout } from "mapbox-gl"; // Only needed for export below. And I don't know why its exported anyway.
import mapboxgl from "mapbox-gl";
import maplibregl from "maplibre-gl";
export { mapboxgl };
export { maplibregl };
export var GeoJSONEnums;
(function (GeoJSONEnums) {
    GeoJSONEnums["fetched"] = "fetched";
    GeoJSONEnums["added"] = "added";
    GeoJSONEnums["temporary"] = "temporary";
})(GeoJSONEnums || (GeoJSONEnums = {}));
export var CUEvents;
(function (CUEvents) {
    CUEvents["geoJSONLoaded"] = "geoJSONLoaded";
    CUEvents["serverDataError"] = "serverDataError";
    CUEvents["campusKeysFetchError"] = "campusKeysFetchError";
    CUEvents["campusKeysError"] = "campusKeysError";
    CUEvents["geoJSONFetchError"] = "geoJSONFetchError";
    CUEvents["customStylesFetchError"] = "customStylesFetchError";
    CUEvents["geoJSONError"] = "geoJSONError";
    CUEvents["piDataLoaded"] = "piDataLoaded";
    CUEvents["campusChange"] = "campusChange";
    CUEvents["roomHover"] = "roomHover";
    CUEvents["roomClick"] = "roomClick";
    CUEvents["poiClick"] = "poiClick";
    CUEvents["buildingClick"] = "buildingClick";
    CUEvents["buildingHover"] = "buildingHover";
    CUEvents["layersSourcesInitialized"] = "layersSourcesInitialized,";
    CUEvents["customStylingValuesLoaded"] = "customStylingValuesLoaded";
})(CUEvents || (CUEvents = {}));
export var HtmlMarkerTypes;
(function (HtmlMarkerTypes) {
    HtmlMarkerTypes["building"] = "building";
    HtmlMarkerTypes["address"] = "address";
})(HtmlMarkerTypes || (HtmlMarkerTypes = {}));
